import { motion } from "framer-motion";
import { themeSelectorIcons } from '../../assets/images/themeSelector';

export default function ThemeList({ themes,
  selectedTheme,
  setSelectedTheme,
  selectedSubTheme,
  setSelectedSubTheme }) {


  const handleThemeClick = (theme) => {
    setSelectedTheme(theme);
    console.log(theme.name)
  };

  const handleSubThemeClick = (subTheme) => {
    setSelectedSubTheme(subTheme);
    console.log(subTheme)
  
    // Ajoute la classe "chose" au card-container
    // const cardContainer = document.getElementById("card-container");
    // cardContainer?.classList.add("chose");
  
    // Ajoute la classe "active" à la side-custom-modal
    // const sideModal = document.querySelector(".side-custom-modal");
    // sideModal.classList.add("active");
  };

  const handleBackButton = () => {
    setSelectedTheme(null)
    setSelectedSubTheme(null)
  }

  return (
    <div className={`card-scroll-container ${selectedTheme ? "subActive" : ""}`}>
        <div id="card-container" className={`card-container ${selectedSubTheme ? "chose" : ""}`}>
      {selectedTheme === null ? (
        themes.map((theme, index) => (
          <motion.div
            key={index}
            className="card-item"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2, type: "spring", stiffness: 80 }}
            onClick={() => handleThemeClick(theme)}
          >
            <div className="card-icons">
          <div className="orange-heart"></div>
          <div className="pine"></div>
        </div>
        <div className="card-body">
          <h3 className="card-title">{theme.name}</h3>
          <p className="card-desc">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper pellentesque nisl in scelerisque.
          </p>
        </div>
          </motion.div>
        ))
      ) : (
        <>
        <motion.button
            className="back-button"
            id="backButton"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, type: "spring", stiffness: 80 }}
            onClick={() => handleBackButton()}
          >
            <img src={themeSelectorIcons.backBtn} alt="BackArrow" className="icon" />
            Retour
        </motion.button>

          {selectedTheme && selectedTheme.subThemes.map((subTheme, index) => (
            <motion.div
              key={index}
              className={`card-item ${selectedSubTheme === subTheme ? "selected" : ""}`}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2, type: "spring", stiffness: 80 }}
              onClick={() => handleSubThemeClick(subTheme)}
            >
              <div className="card-icons">
              <div className="orange-heart"></div>
              <div className="pine"></div>
            </div>
            <div className="card-body">
              <h3 className="card-title">{subTheme}</h3>
              <p className="card-desc">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper pellentesque nisl in scelerisque.
              </p>
            </div>
            </motion.div>
          ))}
        </>
      )}
      </div>
    </div>
  );
}